import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../../../../components/Converter";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";
import { selectBemessungslast } from "../../../../../../store/slices/bemessungslastSlice";

function Verformungsbegrenzung({ verformungsbegrenzung, knicklastDesGebettetenPfahls, greenOn }) {
  const { t } = useTranslation("translation");
  const bemessungslast = useSelector(selectBemessungslast);
  const eta_1_Formula = `\\displaystyle \\eta = \\frac{w _{\\tiny _{0}}}{w_{y}} \\le 1,0`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.deflectionVerifications")}</p>}
      indicesValue={<span>&eta;</span>}
      formulaValue={
        <ToolTip id={"eta_1_Formula"} type={IconType.FORMULA} formula={eta_1_Formula} />
      }
      inputValue={
        <ResultSpan valid={greenOn}>
          {bemessungslast > knicklastDesGebettetenPfahls
            ? "XXX"
            : ConvertToString(verformungsbegrenzung, 2, "XXX")}
        </ResultSpan>
      }
    />
  );
}

export default Verformungsbegrenzung;
